import { Fragment, useEffect, useState } from "react";
import { Separator } from "../../components/separator";
import FeeAndGst from "./stage-c-fee-cost";
interface StageCFeesProps {
  valuationFee: number;
  totalFee: number | string;
  bypassAdminFee: boolean;
  bypassValuationFee: boolean;
}

export interface FeeBreakdown {
  fee_type?: string;
  fee_cost?: number | string;
  fee_reminder?: string | JSX.Element;
}

const StageCFees = (props: StageCFeesProps) => {

  const [feeBreakdown, setFeeBreakdown] = useState<FeeBreakdown[]>([]);

  useEffect(() => {
    const temp: FeeBreakdown[] = [
      {
        fee_type: "Administrative fee",
        fee_cost: props.bypassAdminFee ? "Waived" : 50.0,
        fee_reminder:
          "HDB charges an administrative fee to process an application for a change in flat ownership. The administrative fee is inclusive of GST.",
      },
    ];

    const valuationFeeBreak = {
      fee_type: 'Valuation fee',
      fee_cost: props.bypassValuationFee ? 'Waived' : props.valuationFee,
      fee_reminder: (
        <div className='polymer-fees-400 d-flex flex-column gap-4'>
          <div>
            As the proposed owners have indicated for a new HDB mortgage loan for the change in flat ownership and the current flat is bought from the
            open market, a current market valuation report is required for HDB to determine the mortgage loan ceiling. Valuation fee is inclusive of
            GST and administration fee.
          </div>
          <div>
            Please note that an appointed HDB panel valuer will be assigned to perform the valuation of your flat. By proceeding with the payment, you
            agree and consent to share your contact information with the appointed valuer. The valuer will contact the owners to make an appointment
            to conduct the valuation.
          </div>
        </div>
      ),
    };

    if(props.valuationFee > 50){
      temp.push(valuationFeeBreak);
    }
    setFeeBreakdown([...temp]);
  }, [props.valuationFee, props.bypassAdminFee, props.bypassValuationFee]);

  return (
    <div className="polymer-fees-container">
      <div className="polymer-fees-header">
        <p className="polymer-fees-subheader">Fees</p>
      </div>
      <Separator />
      {feeBreakdown.map((item, index) => {
        const key = index;
        return (
          <Fragment key={key}>
            <div key={item.fee_type} className="polymer-fees-text">
              <div className="polymer-fees-gst-container">
                <p className="polymer-fees-700">{`${item.fee_type}:`}</p>
                <FeeAndGst fee_cost={item.fee_cost} />
              </div>
              {typeof item.fee_reminder === "string"? <p className="polymer-fees-400">{item.fee_reminder}</p> : item.fee_reminder}
            </div>
            {index !== feeBreakdown.length - 1 && <Separator />}
          </Fragment>
        );
      })}
      <Separator />
      <div className="polymer-fees-total-container">
        <p className="polymer-fees-700">Total:</p>
        <FeeAndGst fee_cost={props.totalFee} />
      </div>
    </div>
  );
};

export default StageCFees;
